import axios from 'axios'

axios.defaults.timeout = 60000;
//axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';

import { Loading, Message } from 'element-ui';

axios.defaults.baseURL = 'http://localhost:9004/';

let isdebug=0;
if(isdebug==1)
{
    axios.defaults.baseURL = 'http://localhost:9003/';
}else
{
    axios.defaults.baseURL = 'https://ync.gxqinde.com/adminapi/';
}

let _vue = null;
function init(vue) {
    _vue = vue; 
}

const _Authorization = 'Authorization';
let ipAddress = axios.defaults.baseURL;


// 请求拦截器（在请求之前进行一些配置）
axios.interceptors.request.use((config) => {
    //config.headers.Authorization="";    
    console.log(config);
    if(config.url.indexOf("http")==0||config.url.indexOf("https")==0)
    {
        config.headers['AccessKey'] = '047I4WS1-U51UBO6W-1J4BT21P-MF17IT99-92J8WIHU-944Q4KIW';
        config.baseURL="";
    }
    console.log(config);
    return config;
}, (error) => {
    return Promise.reject(error);
});
// 响应了拦截器（在响应之后对数据进行一些处理）
axios.interceptors.response.use((res) => {
    closeLoading();
    let retData = res.data;
    //如果授权不通过，接口返回401导致报错，进入这里后判断是否登录
    if (retData.Code == 401) {
        toLogin();
        return null;
    }
    return Promise.resolve(res);
}, (error) => {
    closeLoading();
    let httpMessage = '';
    if (error.response) {
        if (error.response.data && error.response.data.message) {
            httpMessage = error.response.data.message;
        } else if (error.response.status == '404') {
            httpMessage = "未找到请求地址";
        }else if (error.response.status == '400') {
            return Promise.resolve(error.request.response);
        }
    }
    else {
        console.log(error);
        httpMessage = '服务器处理异常,请联系管理员'

    }
    _vue.$message.error(httpMessage);
    return Promise.reject(error.response);
});
/*
  url
  params请求后台的参数,如：{name:123,values:['a','b','c']}
  loading是否显示遮罩层,可以传入true.false.及提示文本
  config配置信息,如{timeout:3000,headers:{token:123}}
*/
function post(url, params, loading, config) {
    showLoading(loading);
    axios.defaults.headers[_Authorization] = getToken();
    return new Promise((resolve, reject) => {
        axios.post(url, params, config)
            .then(response => {
                try {
                    resolve(response.data);
                } catch (error) {
                    toLogin();
                }

            }, err => {
                reject(err && err.data && err.data.message ? err.data.message : '服务器处理异常');
            })
            .catch((error) => {
                reject(error)
            })
    })
}

//=true异步请求时会显示遮罩层,=字符串，异步请求时遮罩层显示当前字符串
function get(url, param, loading, config) {
    showLoading(loading);
    axios.defaults.headers[_Authorization] = getToken();
    return new Promise((resolve, reject) => {
        axios.get(url, { params: param }, config)
            .then(response => {
                resolve(response.data)
            }, err => {
                reject(err)
            })
            .catch((error) => {
                reject(error)
            })
    })
}


function ajax(param) {
    let httpParam =
        Object.assign({
            url: '', headers: {},
            param: {}, json: true,
            success: function () { },
            errror: function () { },
            type: 'post',
            async: true,
        }, param);

    httpParam.url = axios.defaults.baseURL + httpParam.url.replace(/\/?/, '');
    httpParam.headers[_Authorization] = getToken();
    var xhr = createXHR();
    xhr.onreadystatechange = function () {
        if (xhr.status == 403 || xhr.status == 401) {
            redirect(xhr.responseText);
            return;
        }
        if (xhr.readyState == 4 && xhr.status == 200) {
            httpParam.success(httpParam.json ? JSON.parse(xhr.responseText) : xhr.responseText);
            return;
        }
        if (xhr.status != 0 && xhr.readyState != 1) {
            httpParam.errror(xhr);
        }
    };
    //初始化请求
    xhr.open(
        httpParam.type,
        httpParam.url,
        httpParam.async
    );
    xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    for (const key in httpParam.headers) {
        xhr.setRequestHeader(key, httpParam.headers[key]);
    }
    let dataStr = '';
    for (const key in httpParam.param) {
        dataStr += key + "=" + httpParam.param[key];
    }
    try {
        xhr.send(dataStr);
    } catch (error) {
        toLogin();
    }
}

function createXHR() {
    if (XMLHttpRequest) {
        return new XMLHttpRequest();
    }
    if (ActiveXObject) {
        if (typeof arguments.callee.activeXString != "string") {
            var versions = [
                "MSXML2.XMLHttp.6.0",
                "MSXML2.XMLHttp",
                "MSXML2.XMLHttp.3.0"
            ];
            for (var i = 0; i < versions.length; i++) {
                try {
                    new ActiveXObject(versions[i]);
                    arguments.callee.activeXString = versions[i];
                    break;
                } catch (e) {
                    console.log('createXHR-出错：' + e);
                }
            }
        }
        return new ActiveXObject(arguments.callee.activeXString);
    }
}

//请求时的加载框------start-------------
let loadingInstance;
let loadingStatus = false;
function showLoading(loading) {
    if (!loading || loadingStatus) {
        return;
    }
    loadingInstance = Loading.service({
        target: '#loading-container',
        customClass: "el-loading",
        text: typeof loading == "string" ? loading : '正在处理.....',
        spinner: 'el-icon-loading',
        background: 'rgba(58, 61, 63, 0.32)'
    });
}

function closeLoading() {
    if (loadingInstance) {
        loadingInstance.close();
    }
    if (loadingStatus) {
        loadingStatus = false;
        if (loadingInstance) {
            loadingInstance.close();
        }
    }

}
//---------------------end---------------------

function toLogin() {
    _vue.$router.push({ path: '/login', query: { R: Math.random() } });
}
function getToken() {
    let tuserInfo = _vue.UserInfo.getUserInfo();
    if (tuserInfo == null) {
        return "";
    }
    return tuserInfo.Token;
}

export default { post, get, ajax, init, ipAddress }


// WEBPACK FOOTER //
// ./src/http/http.js